import React from 'react';
import PostCallForm from '../PostCall/PostCallForm';

const PostCallFormThread = ({ thread }) => {
  const { metadata = {}, data = {}, name = '', id = '' } = thread;

  const initialInputs = {
    meetingOutcome: metadata.meetingOutcome || '',
    customOutcome: metadata.customOutcome || '',
    contactName: metadata.contactName || '',
    contactRole: metadata.contactRole || '',
    companyName: metadata.companyName || '',
    industry: metadata.industry || '',
    geography: metadata.geography || '',
    meetingNotes: metadata.meetingNotes || '',
    bankerActions: metadata.bankerActions || '',
    clientActions: metadata.clientActions || '',
  };

  return (
    <PostCallForm
      existingFormData={initialInputs}
      existingChatHistory={data.chat || []}
      existingSummaryName={name}
      existingThreadId={id}
      postCallResultFull={data.postCallResultFull || ''}
      isReadOnly={true}
      scrollToOutputOnMount={false}
    />
  );
};

export default PostCallFormThread;
